<template>
  <div class="wrapper-container-agreement-policy">
    <div class="container-agreement-policy">
      <!--로고-->
      <div class="wrapper-title">
        <img :src="getAssetImageUrl('common/logos/logo-sconchat-full.png')" alt="Logo" class="logo" aria-label="Go home" />
      </div>
      <div class="wrapper-policy-description">
        <Tabs :tabs="tabs" :active-tab="activeTabIndex" size="small" @tabClick="moveToPolicy" />
        <component :is="currentPolicyComponent" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { getAssetImageUrl } from '@/utils/getAssetImageUrl';
import PolicyInfo from '@/components/self-service/policy/PolicyInfo.vue';
import PolicyPayment from '@/components/self-service/policy/PolicyPayment.vue';
import PolicyPrivacy from '@/components/self-service/policy/PolicyPrivacy.vue';
import PolicyService from '@/components/self-service/policy/PolicyService.vue';
import Tabs from '@/components/shared/composite/Tabs.vue';

const SELF_SERVICE_POLICY_MAP = [
  {
    id: 'service',
    titleKey: 'policy_service',
    policyComponent: PolicyService,
  },
  {
    id: 'privacy',
    titleKey: 'policy_privacy',
    policyComponent: PolicyPrivacy,
  },
  {
    id: 'payment',
    titleKey: 'policy_payment',
    policyComponent: PolicyPayment,
  },
  {
    id: 'info',
    titleKey: 'policy_info',
    policyComponent: PolicyInfo,
  },
];

const route = useRoute();
const router = useRouter();

const tabs = computed<string[]>(() => {
  return SELF_SERVICE_POLICY_MAP.map(({ titleKey }) => titleKey);
});

const activeTabIndex = computed<number>(() => {
  return SELF_SERVICE_POLICY_MAP.findIndex(({ id }) => id === (route.query.id || '').toString());
});

const currentPolicyComponent = computed(() => {
  const { policyComponent } = SELF_SERVICE_POLICY_MAP[activeTabIndex.value] || {};
  return policyComponent;
});

const moveToPolicy = (inx: number) => {
  const { id = '' } = SELF_SERVICE_POLICY_MAP[inx] || {};
  router.push({ name: 'ss-policy', query: { id } });
};

onMounted(() => {
  if (activeTabIndex.value === -1) {
    moveToPolicy(0);
  }
});
</script>

<style scoped lang="scss">
.wrapper-container-agreement-policy {
  width: 100%;
  height: 100dvh;
  min-height: 100dvh;
  max-height: 100dvh;
  overflow-y: auto;
}

.container-agreement-policy {
  display: flex;
  flex-direction: column;
  max-width: 50rem;
  gap: 1rem;
  margin: 0 auto;
  padding: 1rem;
}

.wrapper-title {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .logo {
    width: 10rem;
  }
}

.wrapper-policy-description {
  display: flex;
  flex-direction: column;
}
</style>
